// extracted by mini-css-extract-plugin
export default {"auto-generation":"autoGeneration_auto-generation__VA0ZU","upload-buttons":"autoGeneration_upload-buttons__X+PF3"};